import React from 'react';
import { connect } from 'react-redux';

import Aux from "../../../../../../components/common/Aux";
import NavCollapse from './../NavCollapse';
import NavItem from './../NavItem';

const NavGroup = ({ group, layout, perms }) => {
  const navItems = group.children ? 
    Object.keys(group.children).map(itemKey => {
      const item = group.children[itemKey];
      if (item.permission && !perms.includes("sa") && !perms.includes(item.permission)) {
        return null;
      }
      switch (item.type) {
        case 'collapse':
          return <NavCollapse key={item.id} collapse={item} type="main" />;
        case 'item':
          return <NavItem layout={layout} key={item.id} item={item} />;
        default:
          return null;
      }
    }) : null;

  return (
    <Aux>
      <li key={group.id} className="nav-item pcoded-menu-caption"><label>{group.title}</label></li>
      {navItems}
    </Aux>
  );
};

const mapStateToProps = state => ({
  perms: state.main.userPerms || [],
});

export default connect(mapStateToProps)(NavGroup);
